import axios from 'axios'

const apiUrl = '/api'
let option = { baseURL: apiUrl }
const CancelToken = axios.CancelToken
const instance = axios.create(option)
const BRAND = process.env.BRAND || 'peugeot'

instance.interceptors.request.use(
  function (config) {
    //@todo ver si se puede tomar de alguna constate
    Object.assign(config.headers, { 'Accept-Language': 'es' })
    // Creamos un nuevo Source para cada paticion y asi permitir la cancelación
    const source = CancelToken.source()
    Object.assign(config, { cancelToken: source.token })
    //Redefinir la url de la petición para el entorno development en base al json buscado
    if (config.method === 'put') {
      config.url = 'put.json'
    } else if (config.method === 'delete') {
      config.url = 'delete.json'
    } else if (config.method === 'post') {
      config.url = retriveDevJsonUrl(config.url || 'post.json')
    } else {
      config.url = retriveDevJsonUrl(config.url || '')
    }
    config.method = 'GET'
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

/**
 * Intercepta la petición determinando en local a que archivo json debe apuntar
 * @returns string Url para utilizar direccionada al json en local
 * @param url
 */
function retriveDevJsonUrl(url: string): string {
  // @ts-ignore
  if (UrlMaps[url]) {
    // @ts-ignore
    url = UrlMaps[url]
    console.log('cambiado:', url)
  } else if (url.substr(-5) != '.json') {
    url += '.json'
  }
  return url
}

const UrlMaps = {

  // Mis Vehiculos
  'front/mis-vehiculos': '/'+BRAND+'/front/mis-vehiculos.json',

  // Check DNI
  'front/check-dni': '/'+BRAND+'/front/check-dni.json',
  'front/check-email': '/'+BRAND+'/front/check-email.json',

  '/eventos/config': '/'+BRAND+'/eventos/config.json',
  'front/eventos': '/'+BRAND+'/front/eventos.json',
  'fidelizacion/destacados': '/'+BRAND+'/fidelizacion/destacados.json',
  'fidelizacion/experiencias': '/'+BRAND+'/fidelizacion/experiencias.json',
  'fidelizacion/novedades': '/'+BRAND+'/fidelizacion/novedades.json',
  'fidelizacion/beneficios': '/'+BRAND+'/fidelizacion/beneficios.json',
  'front/ingresar': '/'+BRAND+'/front/ingresar.json',
  'front/actividades/11': '/'+BRAND+'/front/actividades/11.json',
  'front/mis-cupones/11': '/'+BRAND+'/front/mis-cupones/11.json',
  'front/obtener-cupon/11': '/'+BRAND+'/front/obtener-cupon/11.json',
  'front/stock-cupones/11': '/'+BRAND+'/front/stock-cupones/11.json',
  'front/actividades/75': '/'+BRAND+'/front/actividades/75.json',
  'front/mis-cupones/75': '/'+BRAND+'/front/mis-cupones/75.json',
  'front/obtener-cupon/75': '/'+BRAND+'/front/obtener-cupon/75.json',
  'front/stock-cupones/75': '/'+BRAND+'/front/stock-cupones/75.json',
  'front/actividades/170': '/'+BRAND+'/front/actividades/170.json',
  'front/mis-cupones/170': '/'+BRAND+'/front/mis-cupones/170.json',
  'front/obtener-cupon/170': '/'+BRAND+'/front/obtener-cupon/170.json',
  'front/stock-cupones/170': '/'+BRAND+'/front/stock-cupones/170.json',
  'front/mis-beneficios': '/'+BRAND+'/front/mis-beneficios.json',
  'front/actividades/184': '/'+BRAND+'/front/actividades/184.json',
  'front/mis-cupones/184': '/'+BRAND+'/front/mis-cupones/184.json',
  'front/redimir-cupon/1780/7c089ac4a3288cd1dd3504ff5fa8db34': '/'+BRAND+'/front/redimir-cupon/1780/7c089ac4a3288cd1dd3504ff5fa8db34.json',
  //@todo avanzar revisando el resto de los casos
  'front/actividades/199': '/'+BRAND+'/front/actividades/199.json',
  'front/mis-cupones/199': '/'+BRAND+'/front/mis-cupones/199.json',
  'front/obtener-cupon/199': '/'+BRAND+'/front/obtener-cupon/199.json',
  'front/stock-cupones/199': '/'+BRAND+'/front/stock-cupones/199.json',

  // RAM
  'front/actividades/145': '/'+BRAND+'/front/actividades/145.json',
  'front/actividades/145/dias': '/'+BRAND+'/front/actividades/145/dias.json',
  'front/actividades/145/dias/1765228800': '/'+BRAND+'/front/actividades/145/dias/1765228800.json',
  'front/actividades/197': '/'+BRAND+'/front/actividades/197.json',
  'front/actividades/197/dias': '/'+BRAND+'/front/actividades/197/dias.json',
  'front/actividades/197/dias/1757548800': '/'+BRAND+'/front/actividades/197/dias/1757548800.json',

  // Peugeot
  'front/actividades/161': '/'+BRAND+'/front/actividades/161.json',
  'front/actividades/161/dias': '/'+BRAND+'/front/actividades/161/dias.json',
  'front/actividades/161/dias/1765228800': '/'+BRAND+'/front/actividades/161/dias/1765228800.json',

  // Abarth
  'front/actividades/45': '/'+BRAND+'/front/actividades/45.json',
  'front/mis-cupones/45': '/'+BRAND+'/front/mis-cupones/45.json',
  'front/stock-cupones/45': '/'+BRAND+'/front/stock-cupones/45.json',
  'front/actividades/69': '/'+BRAND+'/front/actividades/69.json',

  '/front/predatos': '/pre-datos.json',
  '/vehiculos': '/vehiculo/listar.json',
  '/vehiculos/1': '/vehiculo/ver.json',
  '/front/locaciones/listar': '/locaciones/listar.json',
  'front/locaciones/1': '/locaciones/ver.json',

  'locaciones/1/actividades/1/version/1/dias': '/vehiculo/dias-listar.json',
  'locaciones/1/actividades/1/version/1/dias/1':
    '/vehiculo/horarios-listar.json',

  ubicaciones: '/ubicaciones-listar.json',
  'locaciones/1/actividades': '/locaciones/actividades.json',

  'front/locaciones/1/actividades/listar': '/actividades/listar.json',
  'front/actividades/1': '/actividades/ver.json',
  'front/actividades/1/vehiculos': '/actividades/vehiculos.json',
  dias: '/dias-listar.json',
  provincias: '/provincias-autocomplete.json',
  'provincias/autocompletar': '/provincias-autocomplete.json',
  'provincias/1/localidades': '/localidades-autocomplete.json',
  'provincias/2/localidades': '/localidades2-autocomplete.json',
  'provincias/3/localidades': '/localidades3-autocomplete.json',
  'horarios/1': '/horarios-listar.json',
  'horarios/2': '/horarios-listar-2.json',
  eventos: '/eventos/ver.json',
  'concesionarios/provincias': '/provincias-autocomplete.json',
  'concesionarios/provincias/1/localidades': '/localidades-autocomplete.json',
  'localidades/1/concesionarios': '/concesionarios-autocomplete.json'
}

export default instance
